import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import IconicHeader from '../updated/shared/IconicHeader';
import P2PNavigation from './P2PNavigation';
import CreateOfferForm from './CreateOfferForm';
import MyOffers from './MyOffers';
import EscrowsList from './EscrowsList';
import './OfferManagement.css';

const OfferManagement: React.FC = () => {
  const [activeSection, setActiveSection] = useState<'create' | 'my-offers' | 'escrows'>('create');
  const navigate = useNavigate();

  // Apply theme class based on userType (CaptainBee = orange, normal = green)
  useEffect(() => {
    const userType = localStorage.getItem('userType');
    const userLogged = localStorage.getItem('userlogged');
    
    let themeClass = 'theme-normal';
    
    if (userType && userType !== 'Indexx Exchange') {
      themeClass = 'theme-captain';
    } else if (userType === 'CaptainBee' || userLogged === 'captain') {
      themeClass = 'theme-captain';
    } else if (userType === 'HoneyUser' || userLogged === 'honeyb') {
      themeClass = 'theme-honeyb';
    } else if (userLogged === 'normal' || userType === 'Indexx Exchange') {
      themeClass = 'theme-normal';
    }
    
    document.body.classList.remove('theme-normal', 'theme-captain', 'theme-honeyb');
    document.body.classList.add(themeClass);
    document.documentElement.classList.remove('theme-normal', 'theme-captain', 'theme-honeyb');
    document.documentElement.classList.add(themeClass);
    
    const root = document.getElementById('root');
    if (root) {
      root.classList.remove('theme-normal', 'theme-captain', 'theme-honeyb');
      root.classList.add(themeClass);
    }
  }, []);

  return (
    <div className="binance-offer-management">
      <IconicHeader selectedTab="P2P" onChange={() => {}} />
      <P2PNavigation />
      <div className="p2p-content-container">
        {/* Header */}
        <div className="binance-header">
          <div className="header-content">
            <h1>Offer Management</h1>
            <p>Create and manage your P2P offers</p>
          </div>
        </div>

        {/* Main Content with Side Menu */}
        <div className="offer-management-layout">
          {/* Side Menu */}
          <div className="offer-side-menu">
            <div className="side-menu-header">
              <h3>Menu</h3>
            </div>
            <div className="side-menu-items">
              <button
                className={`side-menu-item ${activeSection === 'create' ? 'active' : ''}`}
                onClick={() => setActiveSection('create')}
              >
                <i className="fas fa-plus-circle"></i>
                <span>Create Offer</span>
              </button>
              <button
                className={`side-menu-item ${activeSection === 'my-offers' ? 'active' : ''}`}
                onClick={() => setActiveSection('my-offers')}
              >
                <i className="fas fa-list"></i>
                <span>My Offers</span>
              </button>
              <button
                className={`side-menu-item ${activeSection === 'escrows' ? 'active' : ''}`}
                onClick={() => setActiveSection('escrows')}
              >
                <i className="fas fa-users"></i>
                <span>Users Who Join Offers</span>
              </button>
            </div>
          </div>

          {/* Content Area */}
          <div className="offer-content-area">
            {activeSection === 'create' && <CreateOfferForm />}
            {activeSection === 'my-offers' && <MyOffers />}
            {activeSection === 'escrows' && <EscrowsList />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferManagement;

